import auth from '../authentication';
import Vue from 'vue';

export default {
    getProperty(context, data, callback) {
        Vue.http.post(window.apiUrl + '/property/get-all', data)
            .then(response => {
                context.error = false;
                context.properties = response.data.data;
                context.total = response.data.total;
                context.message = response.data.message;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.message = response.data.message;
                context.total = 0;
                callback(context);
            })
    },
    getPropertySelect(context, callback) {
        let data = {};
        if (auth.user.profile.role == 5) {
            data.user_id = auth.user.profile.id;
        }
        Vue.http.post(window.apiUrl + '/property/get-select', data)
            .then(response => {
                context.error = false;
                context.properties = response.data.data;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.message = response.data.message;
                callback(context);
            })
    },
    getPropertyDetail(context, id, callback) {
        Vue.http.post(window.apiUrl + '/property/get-detail/' + id)
            .then(response => {
                context.error = false;
                context.property = response.data.data;
                callback(context);
            })
            .catch(response => {
                console.log(response); return false;
                context.error = true;
                context.message = response.data.message;
                callback(context);
            })
    },
    createProperty(context, data, callback) {
        Vue.http.post(window.apiUrl + '/property/add-new', data)
            .then(response => {
                context.error = false;
                context.success = true;
                context.property = response.data.data;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.success = false;
                context.message = response.data.message;
                callback(context);
            })
    },
    updateProperty(context, id, data, callback) {
        Vue.http.post(window.apiUrl + '/property/update-detail/' + id, data)
            .then(response => {
                context.error = false;
                context.success = true;
                context.property = response.data.data;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.success = false;
                context.message = response.data.message;
                callback(context);
            })
    },
    removeProperty(context, id, callback) {
        Vue.http.post(window.apiUrl + '/property/remove/' + id, {})
            .then(response => {
                context.error = false;
                context.success = true;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.success = false;
                callback(context);
            })
    }
};